import Head from "next/head";
import { useTranslation } from '@/components/useTranslation';

export default function Datenschutz() {

    const t = useTranslation();

    return (
        <>
            <Head>
                <title>Resenas123 | {t.privacy_policy} </title>
            </Head>
            <div className='max-w-6xl py-32 mx-auto md:px-8 sub-page-content'>
                <div className="relative w-full ">
                    <div className="relative">
                        <div className="flex items-start justify-between p-4 border-b rounded-t">
                            <h1 className="text-3xl font-semibold text-gray-900"> {t.privacy_policy} </h1>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="modal-inner">
                                <div className="py-3">
                                    <h6>{t.datenschutz_title1}</h6>
                                    <p> {t.datenschutz_description1}</p>
                                    <p>{t.datenschutz_description2}</p>
                                    <div className="py-3" dangerouslySetInnerHTML={{__html: t.datenschutz_description_list}}></div>
                                    <p className="py-3">{t.datenschutz_description3} </p>
                                    <div className="pb-3" dangerouslySetInnerHTML={{__html: t.datenschutz_description4}}></div>
                                    <p className="py-2">{t.datenschutz_description5} </p>
                                    <p>{t.datenschutz_description6}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title2}</h6>
                                    <p>{t.datenschutz_description7}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title3}</h6>
                                    <p>{t.datenschutz_description8}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title4}</h6>
                                    <p>{t.datenschutz_decsription9}</p>
                                    <p>{t.datenschutz_decsription10}</p>
                                    <a href="https://www.google.com/fonts#AboutPlace:about
                                  https://www.google.com/policies/privacy/"><strong>https://www.google.com/fonts#AboutPlace:about
                                        https://www.google.com/policies/privacy/</strong></a>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title5}</h6>
                                    <p>{t.datenschutz_description11}</p>
                                    <p>{t.datenschutz_description12}</p>
                                    <p>{t.datenschutz_description13}</p>
                                    <p>{t.datenschutz_description14}</p>
                                    <p>
                                        <a href="https://tools.google.com/dlpage/gaoptout?hl=de"><strong>http://tools.google.com/dlpage/gaoptout?hl=de</strong></a>
                                        {t.datenschutz_description15}
                                    </p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title6}</h6>
                                    <p>{t.datenschutz_description17}</p>
                                    <p>{t.datenschutz_description18} </p>
                                    <p>
                                        <a href="https://www.google.com/intl/de/policies/privacy/"><strong>https://www.google.com/intl/de/policies/privacy/</strong></a>
                                        {t.datenschutz_description19}
                                    </p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title7}</h6>
                                    <p>{t.datenschutz_description20}</p>
                                    <p>{t.datenschutz_title20_1}</p>
                                    <p>
                                        <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"><strong>https://www.paypal.com/de/webapps/mpp/ua/privacy-full</strong></a>
                                    </p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title8}</h6>
                                    <p>{t.datenschutz_description21}</p>
                                    <p>{t.datenschutz_description22} </p>
                                    <p>{t.datenschutz_description23} </p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.datenschutz_title9}</h6>
                                    <p>{t.datenschutz_description24}</p>
                                    <p>{t.datenschutz_description25}</p>
                                    <div className="py-3" dangerouslySetInnerHTML={{__html: t.datenschutz_list26}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}